import { render, staticRenderFns } from "./NoticeItem.vue?vue&type=template&id=f17b5a0a&scoped=true&lang=pug&"
import script from "./NoticeItem.vue?vue&type=script&lang=js&"
export * from "./NoticeItem.vue?vue&type=script&lang=js&"
import style0 from "./NoticeItem.vue?vue&type=style&index=0&id=f17b5a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17b5a0a",
  null
  
)

export default component.exports